export default "__VITE_ASSET__BFPdCXPs__"